import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment } from '@material-ui/core';

const CustomUiBuilderTextField = (props) => {
  const {
    value,
    label,
    required,
    maxLength,
    endAdornment,
    className,
    onChangeInput,
    isAdornment,
    error,
    multiline,
    errorType,
  } = props;
  const [inputProps, setInputProps] = useState({});
  const [adormentInput, setAdormentValue] = useState({});

  useEffect(() => {
    let InputPropsObj = {};
    InputPropsObj.maxLength = maxLength || 60;
    setInputProps(InputPropsObj);
  }, [props]);
  // const [error, setError] = useState(false);

  const handleInputChange = (e) => {
    // e.target.value ? setError(false) : setError(true);
    return onChangeInput(e);
  };

  useEffect(() => {
    let InputPropsObj = {};
    if (endAdornment) {
      InputPropsObj.endAdornment = (
        <InputAdornment position='end'>
          <span className='cusotm-text-field-end-adornment'>{`${value?.length}/${maxLength}`}</span>
        </InputAdornment>
      );
    }
    setAdormentValue(InputPropsObj);
  }, [props]);

  const checkErrorMsg = () => {
    if (errorType === 'validUrl') return 'Enter valid Url';
    if (errorType === 'safeDomain') return 'URL points to a restricted or untrusted domain';
    if (errorType === 'required') return `${label} is required`;
    return error ? `${label} is required` : undefined;
  };

  return (
    <TextField
      label={label}
      required={required}
      className={className}
      value={value}
      error={error}
      helperText={checkErrorMsg()}
      onChange={(e) => handleInputChange(e)}
      inputProps={inputProps}
      InputProps={isAdornment ? adormentInput : null}
      multiline={multiline || false}
      maxLength={maxLength}
    />
  );
};

export default CustomUiBuilderTextField;
